import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import dateSetting from '../../utils/dateSetting';
import axios from 'axios';
import { Col, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ballImage from '../../assets/img/icon/ball_icon.png';
import HitCourseChart from '../../components/chart/HitCourseChart';
import PitchZoneChart from '../../components/chart/PitchZoneChart';
import DefaultLoader from '../../components/loader/DefaultLoader';

function SprayBattingChartMain({profile, leagueType = 'KBO'}) {
    const [cookies] = useCookies(['hiball_token']);
    let [recordArr, setRecordArr] = useState([]);
    let [recordType, setRecordType] = useState('hit');
    let dateObj = dateSetting();
    const { t } = useTranslation();
    let [loading, setLoading] = useState(false);

    let useLang = localStorage.getItem('language');

    useEffect(() => {
        setLoading(false);
        let params = {
            recordType: 'futuresRecordService',
            seasons: dateObj['season'],
            // gameTypeCode: 4206,
            leagueTypeCodes: leagueType,
            batterIds: profile['playerId'],
            authToken:JSON.stringify(cookies['hiball_token'])
        }

        if(recordType === 'hit') {
            params['recordName'] = 'futuresTrackManHitRecord';
        } else if(recordType === 'hardHit') {
            params['recordName'] = 'futuresTrackManHardHitRecord';
        } else {
            params['recordName'] = 'futuresTrackMan50UpperHitRecord';
        }

        axios({
            url : `${process.env.REACT_APP_API_URL}`, params
        }).then((result) => {
            setLoading(true);
            let record = result['data']['result'];
            setRecordArr(record);
        })
    }, [recordType]);

    function recordTypeHandler(event) {
        let type = event.target.value;
        setRecordType(type);
    }

    return (
    <>
    <div style={{position:'absolute', top: '7px', left: '7px'}}>
        <Form.Group onChange={recordTypeHandler} style={{display:'inline-block', height: '29px'}}>
            <Form.Select size="sm" defaultValue={dateObj['selectboxSeason']}>
                <option value={'hit'}>안타</option>
                <option value={'hardHit'}>강한타구</option>
                <option value={'upperHit'}>안타확률 50% 이상</option>
            </Form.Select>
        </Form.Group>
    </div>
    <div className="boxTitle"><img src={ballImage} style={{height:'25px'}} /> {t('spread')}(T)</div>
    {
        loading ?
        <div style={{display: 'flex', justifyContent: 'space-evenly', flexDirection:'column', marginTop: '10px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'center'}}>
                <div>vs우</div>
                <div style={{textAlign: 'center', border: '1px solid #ccc'}}>
                    <div style={{backgroundColor: '#ddd'}}>직구계열</div>
                    <div style={{display: 'flex'}}>
                        <PitchZoneChart width={100} height={100} data={recordArr['rightHandsFastBall']}/>
                        <HitCourseChart size={100} data={recordArr['rightHandsFastBall']}/>
                    </div>
                </div>
                <div style={{textAlign: 'center', border: '1px solid #ccc'}}>
                    <div style={{backgroundColor: '#ddd'}}>휘는계열</div>
                    <div style={{display: 'flex'}}>
                        <PitchZoneChart width={100} height={100} data={recordArr['rightHandsHangingBall']}/>
                        <HitCourseChart size={100} data={recordArr['rightHandsHangingBall']}/>
                    </div>
                </div>
                <div style={{textAlign: 'center', border: '1px solid #ccc'}}>
                    <div style={{backgroundColor: '#ddd'}}>떨어지는계열</div>
                    <div style={{display: 'flex'}}>
                        <PitchZoneChart width={100} height={100} data={recordArr['rightHandsOffSpeedBall']}/>
                        <HitCourseChart size={100} data={recordArr['rightHandsOffSpeedBall']}/>
                    </div>
                </div>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'center'}}>
                <div>vs좌</div>
                <div style={{textAlign: 'center', border: '1px solid #ccc'}}>
                    <div style={{backgroundColor: '#ddd'}}>직구계열</div>
                    <div style={{display: 'flex'}}>
                        <PitchZoneChart width={100} height={100} data={recordArr['leftHandsFastBall']}/>
                        <HitCourseChart size={100} data={recordArr['leftHandsFastBall']}/>
                    </div>
                </div>
                <div style={{textAlign: 'center', border: '1px solid #ccc'}}>
                    <div style={{backgroundColor: '#ddd'}}>휘는계열</div>
                    <div style={{display: 'flex'}}>
                        <PitchZoneChart width={100} height={100} data={recordArr['leftHandsHangingBall']}/>
                        <HitCourseChart size={100} data={recordArr['leftHandsHangingBall']}/>
                    </div>
                </div>
                <div style={{textAlign: 'center', border: '1px solid #ccc'}}>
                    <div style={{backgroundColor: '#ddd'}}>떨어지는계열</div>
                    <div style={{display: 'flex'}}>
                        <PitchZoneChart width={100} height={100} data={recordArr['leftHandsOffSpeedBall']}/>
                        <HitCourseChart size={100} data={recordArr['leftHandsOffSpeedBall']}/>
                    </div>
                </div>
            </div>
        </div>
        :
        <DefaultLoader />
    }
    </>
    )
}

export default SprayBattingChartMain;